import React, { useCallback } from 'react';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';

import greenStar from './green-star.svg';
import { useDeactivateDemoStore } from './hooks/use-deactivate-demo-store';
import { messages } from './messages';
import style from './style.module.less';

export const DemoStoreDeactivateBanner = () => {
  const { deactivateDemoStore } = useDeactivateDemoStore();

  const onDeactivateDemoStoreClick = useCallback(() => {
    deactivateDemoStore('grid_header_banner');
  }, [deactivateDemoStore]);
  return (
    <BannerMessageV2
      className={style['header-demo-banner']}
      content={
        <>
          <img alt='Green star icon' src={greenStar} />
          <Text textType={TextType.Paragraph} value={messages.inDemoStore} />
          <Button className={style['deactivate-button']} onClick={onDeactivateDemoStoreClick} theme='unstyled'>
            <Text className={style['deactivate-text']} textType={TextType.Paragraph} value={messages.deactivateStore} />
          </Button>
        </>
      }
      status={BannerStatus.Custom}
    />
  );
};
